import { runResourceSync } from "services/sync/engine";
import { POLICY } from "services/sync/policies";
import ChatService from 'services/chat.service';

export function forConversation({ syncEngine, scope, repository, repositories, params, cached, onCall, onFinally, force }) {
  const { lineId, chatId } = params;
  return runResourceSync(syncEngine, scope, `(lineId:${lineId})-(chatId:${chatId})`, {
    cached,
    repository,
    onCall,
    onFinally,
    fetchRemote: ({ lastSyncAt }) => ChatService.getContent(lineId, chatId, lastSyncAt),
    selectItems: (response) => response.payload.chatContent,
    selectServerTime: (response) => null,
    mode: "append",
    policy: POLICY.EVENT,
    force
  });
};